import React from 'react';

import Icon, { IconProp } from '~components/icon';

interface ComponentProps {
  icon: IconProp;
  label: string; // accessible name + tooltip (e.g. "Bold")
  onActivate: () => void;
  isActive?: boolean;
  disabled?: boolean;
}

/**
 * One formatting control in the rich-text editor toolbar.
 *
 * `onMouseDown` is prevented so clicking a button never steals focus from the editor: the text
 * selection survives, so toggling Bold etc. applies to what the author had selected.
 */
const RichTextToolbarButton: React.FC<ComponentProps> = ({ icon, label, onActivate, isActive = false, disabled = false }) => (
  <button
    type="button"
    className={`rich-text-toolbar-btn${isActive ? ' is-active' : ''}`}
    onMouseDown={(e) => e.preventDefault()}
    onClick={onActivate}
    disabled={disabled}
    aria-label={label}
    aria-pressed={isActive}
    title={label}
  >
    <Icon icon={icon} />
  </button>
);

export default RichTextToolbarButton;
